import { safeLocalStorage } from '@/lib/browserStorage';
const KEY = "drilllog:order:v1";

export function loadOrder() {
  try {
    const raw = safeLocalStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

export function saveOrder(items) {
  try {
    safeLocalStorage.setItem(KEY, JSON.stringify(items));
  } catch (e) {
    console.error("Unable to save order", e);
  }
}

export function mergeRecommendedItems(recommended) {
  const current = loadOrder();
  const next = [...current];

  recommended.forEach((item) => {
    const key = `${item.category}::${item.name}`.toLowerCase();
    const existing = next.find(
      (x) => `${x.category}::${x.name}`.toLowerCase() === key
    );

    // `item.quantity` is the amount required to reach the stocktake
    // Build to target. Never stack the same recommendation on repeated
    // clicks: account for anything already present on the order sheet,
    // including quantities the user has added manually.
    const requiredToBuild = Math.max(0, Number(item.quantity || 0));
    const alreadyOnOrder = Number(existing?.quantity || 0);
    const additionalRequired = Math.max(0, requiredToBuild - alreadyOnOrder);

    if (additionalRequired <= 0) return;

    if (existing) {
      existing.quantity = alreadyOnOrder + additionalRequired;
      existing.source = "Stocktake recommendation";
    } else {
      next.push({
        ...item,
        quantity: additionalRequired,
        source: "Stocktake recommendation",
        id:
          globalThis.crypto?.randomUUID?.() ||
          `${Date.now()}-${Math.random()}`,
      });
    }
  });

  saveOrder(next);
  return next;
}

export { KEY as ORDER_STORAGE_KEY };
